import React from "react";
import "./App.css";

import Individual from "./pages/Individuals/Individual";
import Layout from "./pages/Layout/Layout";

function App() {
  return (
    <div className="App">
      <Layout>
        <Individual />
      </Layout>
    </div>
  );
}

export default App;
